var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [_c("v-page-loading")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading",
            },
          ],
        },
        [
          _c("div", { staticClass: "grid-container" }, [
            _c("div", { staticClass: "action action--page" }, [
              _c(
                "button",
                {
                  staticClass: "button button--prev",
                  attrs: { title: _vm.$t("nav.weeks"), tabindex: "-1" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getLastPage.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("nav.weeks")))]
              ),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.getPageTitle))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-container" }, [
            this.$route.meta.method == "update"
              ? _c("div", { staticClass: "grid-x" }, [
                  _c("div", { staticClass: "cell small-auto medium-7" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("kolonne.title")) + ":"),
                    ]),
                    _vm._v(
                      "\n          " + _vm._s(_vm.kolonne) + "\n          "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.$t("date")) + ":")]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("moment")(_vm.date, "DD.MM.YYYY")) +
                        "\n          "
                    ),
                    !_vm.isWeekend && _vm.daily_entries.length >= 1
                      ? _c(
                          "div",
                          { staticClass: "u-extra-small-margin--top" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button secondary",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.saveAllEntries.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("weeks.button.saveall")))]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cell small-auto medium-5 text-right" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button button--prev button--calendar",
                          attrs: {
                            role: "button",
                            type: "submit",
                            title: _vm.$t("backward"),
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.getPrevDay.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("backward")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button button--next button--calendar",
                          attrs: {
                            role: "button",
                            type: "submit",
                            title: _vm.$t("forward"),
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.getNextDay.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("forward")))]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isWeekend
              ? _c("div", { staticClass: "grid-x" }, [
                  _c(
                    "div",
                    { staticClass: "cell auto" },
                    [
                      this.$route.meta.method == "create"
                        ? _c(
                            "div",
                            { staticClass: "c-day-planner" },
                            [
                              _c("v-week-day-crud", {
                                attrs: { method: _vm.createMethod },
                                on: { refresh: _vm.refreshView },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "c-day-planner" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-day-planner__add-button-wrapper text-center",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button button--action button--action--add-project",
                                      attrs: {
                                        title: _vm.$t("weeks.project.add"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleCreateForm.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "show-for-sr" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("weeks.project.add"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.insertCreateView
                                ? [
                                    _c("v-week-day-crud", {
                                      attrs: { method: _vm.createMethod },
                                      on: { refresh: _vm.refreshView },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.sorted_entries,
                                function (entry, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "box u-no-padding",
                                    },
                                    [
                                      _vm._l(
                                        _vm.weekday_sort_order,
                                        function (order, index) {
                                          return _c("div", { key: index }, [
                                            entry.id == order.entry_id
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-day-planner__index",
                                                    attrs: { title: "Index" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-week-day-sort-input",
                                                      {
                                                        attrs: {
                                                          entryId:
                                                            order.entry_id,
                                                          sortOrder:
                                                            order.sort_order,
                                                        },
                                                        on: {
                                                          updateSortOrder:
                                                            _vm.updateSortOrder,
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("v-week-day-crud", {
                                        attrs: {
                                          method: _vm.updateMethod,
                                          parentToSave: _vm.saveAll,
                                          entry: entry,
                                        },
                                        on: { refresh: _vm.refreshView },
                                      }),
                                    ],
                                    2
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                      _vm._v(" "),
                      this.$route.meta.method == "update"
                        ? [
                            !_vm.isWeekend && _vm.daily_entries.length >= 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "u-extra-small-margin--top u-extra-medium-margin--bottom",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button secondary",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.saveAllEntries.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("weeks.button.saveall"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.daily_entries.length == 0
                              ? _c("div", [
                                  _c(
                                    "h2",
                                    { staticClass: "u-error text-center" },
                                    [_vm._v(_vm._s(_vm.$t("no_results_found")))]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _c(
                  "div",
                  {
                    staticClass:
                      "callout warning text-center u-extra-small-margin--top",
                  },
                  [_vm._v(_vm._s(_vm.$t("weeks.warning.weekend")))]
                ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("v-dialog", {
        attrs: {
          isVisible: _vm.isVisible,
          messageType: _vm.messageType,
          content: _vm.dialogContent,
        },
        model: {
          value: _vm.isVisible,
          callback: function ($$v) {
            _vm.isVisible = $$v
          },
          expression: "isVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }